import {withQuery} from "ufo";
import type {UseOffsetPaginationReturn} from "@vueuse/core";
import type {ActiveHeadEntry} from "@unhead/schema";
import type {UseHeadInput} from "unhead";
import type {MergeHead} from "zhead";

export default (offsetPagination: UseOffsetPaginationReturn) => {
  let prev: ActiveHeadEntry<UseHeadInput<MergeHead>> | void | null = null;
  const watchHandle = watchEffect(() => {
    const {isFirstPage, isLastPage, currentPage} = offsetPagination;
    const {path} = useRoute();

    const createLink = (offset: number) =>
      withQuery(path, {page: currentPage.value + offset});

    const pageLinks = [
      !isFirstPage.value && {rel: "prev", href: createLink(-1)},
      !isLastPage.value && {rel: "next", href: createLink(1)},
    ].filter(Boolean) as {rel: string; href: string}[];

    prev?.dispose();
    prev = useHead({link: pageLinks});
  });

  onBeforeUnmount(() => {
    prev?.dispose();
    watchHandle.stop();
  });
};
